/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Courseofstudy2Inputs */

const en__field_courseofstudy2 = /** @type {(inputs: _Field_Courseofstudy2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Course of Study`)
};

const de__field_courseofstudy2 = /** @type {(inputs: _Field_Courseofstudy2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studiengang`)
};

/**
* | output |
* | --- |
* | "Course of Study" |
*
* @param {_Field_Courseofstudy2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_courseofstudy2 = /** @type {((inputs?: _Field_Courseofstudy2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Courseofstudy2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_courseofstudy2(inputs)
	return de__field_courseofstudy2(inputs)
});
export { _field_courseofstudy2 as "_field_courseOfStudy" }